import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { getClassicLayoutGroup } from "entities/configurator/model/layoutMeta";
import { OptionTemplate } from "shared/api/middleware-api-client";
import { LayoutChoiceGrid } from "./LayoutChoiceGrid";
import { LayoutGroupShell } from "./LayoutGroupShell";
import { StandingLayoutChoices } from "./StandingLayoutChoices";
import { useLayoutSelector } from "./hooks/useLayoutSelector";

export const GroupedLayoutSelector = ({
  layouts,
}: {
  layouts: OptionTemplate[];
}) => {
  const { layout, closeLayoutGroup, staanderPosition, updateStaander } =
    useConfigurationOptionsContext();

  const { onChangeLayout } = useLayoutSelector();
  const isClassicLayoutGroup = getClassicLayoutGroup(layouts[0]?.code) !== null;

  return (
    <LayoutGroupShell onBack={closeLayoutGroup}>
      {isClassicLayoutGroup ? (
        <StandingLayoutChoices
          layouts={layouts}
          selectedLayoutCode={layout?.code}
          staanderPosition={staanderPosition}
          onChangeLayout={onChangeLayout}
          onChangeStaander={updateStaander}
        />
      ) : (
        <LayoutChoiceGrid
          data-testid="width-opdekdeur-buttons"
          layouts={layouts}
          selectedLayoutCode={layout?.code}
          onChangeLayout={onChangeLayout}
          className="gg-mt-2.5 sm:gg-mt-5"
        />
      )}
    </LayoutGroupShell>
  );
};
